/**
 * API клиент для общей статистики аккаунтов.
 */

import { getAuthHeaders } from './auth-headers';
import { SUPABASE_FUNCTIONS_URL } from './config';

export type AccountInsightRow = {
  account_id: string;
  username: string;
  name: string | null;
  avatar_url: string | null;
  tags: string[];
  followers_count: number | null;
  impressions: number | null;
  reach: number | null;
  interactions: number | null;
  followers_delta: number | null;
  prev_impressions: number | null;
  prev_reach: number | null;
  prev_interactions: number | null;
  prev_followers_delta: number | null;
  error: string | null;
};

export type AccountInsightsResponse = {
  rows: AccountInsightRow[];
  cached_count: number;
  fetched_count: number;
};

export async function fetchAccountInsightsBatch(params: {
  since: number;
  until: number;
  prevSince?: number;
  prevUntil?: number;
  forceRefresh?: boolean;
}): Promise<AccountInsightsResponse> {
  const headers = await getAuthHeaders();

  const response = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/account-insights`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      since: params.since,
      until: params.until,
      prev_since: params.prevSince,
      prev_until: params.prevUntil,
      force_refresh: params.forceRefresh,
    }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Ошибка сервера: ${response.status}`);
  }

  return response.json();
}
